const getAverageAnnotations = ({ averages = [] }) => {
  if (!averages || !averages.length) {
    return [];
  }

  return averages.map((average, index) => ({
    type: 'line',
    borderColor: '#fdbf47',
    borderWidth: 3,
    yMin: average.value,
    yMax: average.value,
    xMax: index + 0.5,
    xMin: index - 0.5,
  }));
};

export default getAverageAnnotations;
